import { Field } from '@/catalog/types/field';
import { ProductEntity } from '@/product/types';

export function returnFieldValue(this: Pick<Field, 'getValue'>, product: ProductEntity) {
  return this.getValue(product);
}
